"use strict";

exports.__esModule = true;
exports.dataItemChartV2CardProps = exports.REALTIME_ITEMS = exports.MTC_ITEMS = exports.HISTORICAL_ITEMS = exports.DataItemChartV2Widget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DataItemChartV2Element = require("./DataItemChartV2Element");
var _ChartCard = require("../common/ChartCard");
var _DataItemChartV2Fields = require("./DataItemChartV2Fields");
var _DataItemChartV2Thumbnail = require("./DataItemChartV2Thumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var REALTIME_ITEMS = exports.REALTIME_ITEMS = "realtime";
var HISTORICAL_ITEMS = exports.HISTORICAL_ITEMS = "historical";
var MTC_ITEMS = exports.MTC_ITEMS = "mtc";

// A title the user wrote always shows; the generic "Data items" only when
// the widget is tall enough that the header does not eat the chart.
var dataItemChartV2CardProps = exports.dataItemChartV2CardProps = function dataItemChartV2CardProps(props) {
  var _props$title, _props$title2;
  return {
    title: ((_props$title = props.title) == null ? void 0 : _props$title.mainText) || (props.height >= _ChartCard.SHORT_CARD_HEIGHT ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DataItemChartV2Widget.card.title",
      defaultMessage: "Data items"
    }) : undefined),
    subtitle: (_props$title2 = props.title) == null ? void 0 : _props$title2.subText,
    // The card shows the title; keep echarts from drawing a second one.
    elementProps: {
      title: Object.assign({}, props.title, {
        show: false
      })
    }
  };
};
var DataItemChartV2Widget = exports.DataItemChartV2Widget = {
  name: "DataItemChartV2Widget",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DataItemChartV2Widget.label",
    defaultMessage: "Data Item Chart V2 (Beta)"
  }),
  icon: "timeline-area-chart",
  group: _widgetGroups.RAW_DATA_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DataItemChartV2Widget",
      props: Object.assign({
        width: 256,
        height: 256,
        chartItems: {
          props: []
        }
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["title", "toolbox", "statistics", "visualMap", "chartItems", "controls", "dataItems", "realtimeItems", "historicalItems"],
  requiresProps: ["x", "y", "width", "height", "dataItemSource"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 256,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_DataItemChartV2Element.DataItemChartV2Element, dataItemChartV2CardProps),
    Fields: _DataItemChartV2Fields.DataItemChartV2Fields,
    Thumbnail: _DataItemChartV2Thumbnail.DataItemChartV2Thumbnail
  }
};